<div class="admin-page">
  <tm1-typography type="title-page">Admin</tm1-typography>

  <tm1-tabs no-overflow="true" activeid="venues" orientation="horizontal" style="width: 100%;">
    <tm1-tab id="venues" label="Venues">Venues</tm1-tab>
    <tm1-tab-panel id="tabPanelVenues" style="margin-top: 1%;">
      <app-venues-tab></app-venues-tab>
    </tm1-tab-panel>
  </tm1-tabs>
</div>
